import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { isSentryEnabled } from "@/lib/sentry";

async function getSupabaseClient() {
  const { supabase } = await import("@/lib/supabaseClient");
  return supabase;
}

function setUserContext(user: { id: string } | null) {
  Sentry.setUser(user ? { id: user.id } : null);
}

export default function SentryUserLifecycle() {
  useEffect(() => {
    if (!isSentryEnabled()) return;

    let disposed = false;
    let unsubscribe: (() => void) | null = null;

    const syncSession = async () => {
      const supabase = await getSupabaseClient();
      if (disposed) return;

      const { data, error } = await supabase.auth.getSession();
      if (disposed || error) return;

      setUserContext(data.session?.user?.id ? { id: data.session.user.id } : null);

      const {
        data: { subscription },
      } = supabase.auth.onAuthStateChange((_event, session) => {
        setUserContext(session?.user?.id ? { id: session.user.id } : null);
      });

      unsubscribe = () => subscription.unsubscribe();
    };

    void syncSession();

    return () => {
      disposed = true;
      unsubscribe?.();
    };
  }, []);

  return null;
}
